import type {RegisteredRuleSchemaComponent} from '@github-ui/repos-rules-types/rules-types'
import {FilePathList} from './FilePathList'

export function FilePathRestrictions({field, value, onValueChange, readOnly}: RegisteredRuleSchemaComponent) {
  return (
    <FilePathList
      field={field}
      value={value}
      onValueChange={onValueChange}
      readOnly={readOnly}
      boxName="Restricted file paths"
      buttonName="Add restricted path"
      blankslate="No restricted paths"
    />
  )
}
